import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import FontColor from "%/dynamic-components/render-engine/options/text-options/font-color";
import FontSize from "%/dynamic-components/render-engine/options/text-options/font-size";
import FontWeight from "%/dynamic-components/render-engine/options/text-options/font-weight";
import FontFamily from "%/dynamic-components/render-engine/options/text-options/font-family";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";

export default class BasicTextOptions extends BaseOptionsBundle {

  optionTitle = "Basic Typography";
  static optionClassName = "i-dynamic-text";
  inspectorToolGroup = "basic-text";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.BASIC_TEXT_TOOL_SET,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  constructor(values = {}) {
    super(values, [
      FontFamily,
      FontColor,
      FontSize,
      FontWeight,
    ]);
  }
}
